const IconArrowRight = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66675 15.1002L11.7556 10.0002L6.66675 4.90016L8.23341 3.3335L14.9001 10.0002L8.23341 16.6668L6.66675 15.1002Z"
      fill="#FF3333"
    />
  </svg>
);

export default IconArrowRight;
